import { render, staticRenderFns } from "./WarningAnimate.vue?vue&type=template&id=76c51d36&scoped=true&"
import script from "./WarningAnimate.vue?vue&type=script&lang=js&"
export * from "./WarningAnimate.vue?vue&type=script&lang=js&"
import style0 from "./WarningAnimate.vue?vue&type=style&index=0&id=76c51d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c51d36",
  null
  
)

export default component.exports